import {classNames, layout, typography, ViewContent} from "@variocube/cube-ui";
import * as React from "react";
import {PropsWithChildren} from "react";
import {stylesheet} from "typestyle";

export function GridViewContent({children}: PropsWithChildren<{}>) {
    return (
        <ViewContent className={classNames(layout.vertical, layout.center, layout.alignCenter, styles.gridContainer)}>
            {children}
        </ViewContent>
    )
}

interface GridItemProps extends PropsWithChildren<{onClick: () => any; label: string;}>{ }

export function GridItem({onClick, label, children}: GridItemProps) {
    return (
        <div className={styles.gridItem} onClick={onClick}>
            <div className={styles.text}>
                <div className={typography.title}>
                    {label}
                </div>
                <div>{children}</div>
            </div>
        </div>
    );
}

const backgroundGradient = "radial-gradient(#fff, transparent), linear-gradient(#f0f0f0, #e0e0e0)";
const boxShadow = "0 0 0.5rem -0.25rem rgba(0, 0, 0, 0.5)";

const styles = stylesheet({
    gridContainer: {
        display: "flex",
        flexFlow: "row wrap",
        background: backgroundGradient,
    },
    gridItem: {
        flex: 1,
        margin: "0.75em",
        minWidth: "14em",
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        borderRadius: "1em",
        boxShadow,
        maxWidth: "calc(33% - 0.75em)",
        cursor: "pointer"
    },
    text: {
        padding: "0.75em 1.25em",
        textAlign: "center",
        // backgroundColor: "#f0f0f0",
        borderRadius: "0 0 1em 1em"
    }
});
